export { getTranslatableContent } from '../state/translations/get'
export { mergeTranslatedContent } from '../state/translations/merge'
export type {
  DescriptorsByComponentType,
  DescriptorsByProp,
} from '../state/modules/prop-controller-descriptors'
export type { ElementData, Data, Element } from '../state/read-only-state'
export type { TranslationDto } from '@makeswift/controls'
